const api_url = process.env.MIX_API_URL;
const app_url = process.env.MIX_APP_URL;

export  {
    api_url ,
    app_url
}
